export const LOGO_URL =
  "https://flowstatesolutions.ai/wp-content/uploads/2021/12/FS_Icon_Purple_Web-scaled.jpg";

export const RESURL = "https://dummyjson.com/recipes";

export const PAGE_SIZE = 8;

export const PHOTO_URL = "https://avatars.githubusercontent.com/u/65893784?v=4";
